import React, { FC } from 'react'
import { useTheme } from '@shared/lib'
import { Partners, usePartner } from '@shared/lib/partner'

const YellowFireIcon: FC = () => {
  const theme = useTheme()
  const { partner } = usePartner()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19531 14.9807C4.19531 14.3924 4.22607 13.9635 4.28937 13.6429C4.50762 12.1 5.15531 10.1749 6.7323 7.44359C7.12307 6.7668 8.11359 6.81357 8.53006 7.47486C8.59742 7.58182 8.66512 7.68677 8.73307 7.78987C9.69801 5.89632 10.8845 4.37918 12.178 3.27367C13.0806 2.50222 14.3287 3.37114 14.6607 4.51116C15.1402 6.1576 16.2316 7.54184 17.3196 8.92178C18.7604 10.7493 20.1953 12.5692 20.1953 14.9807C20.1953 19.1863 17.1452 22.5112 13.0789 22.9348C12.8324 22.9654 12.54 22.9804 12.1952 22.9804C7.69524 22.9803 4.19531 19.4858 4.19531 14.9807ZM14.0831 15.1138C14.6977 16.0099 15.1953 16.7355 15.1953 18.0638C15.1953 19.7305 13.9852 20.9805 12.2331 20.9805C10.481 20.9805 9.19531 19.7305 9.19531 18.0638C9.19531 15.2627 10.6977 12.6827 12.2331 10.9805C12.6986 13.0949 13.4525 14.1941 14.0831 15.1138Z"
        fill={partner === Partners.CDEK || partner === Partners.GENBANK ? theme.colors.icon.white : '#FAC031'}
      />
    </svg>
  )
}

export default YellowFireIcon
